


































































































import { useMachine } from "@xstate/vue";
import { defineComponent, ref, watch } from "@vue/composition-api";

import { Item } from "@/tools/msa/models/item";
import isLoading from "@/tools/msa/stores/loading";
import document from "@/tools/msa/stores/document";
import { machine } from "@/tools/msa/utils/machine";
import ProcessStep from "@/components/steps/ProcessStep.vue";
import ItemTable from "@/tools/msa/components/table/ItemTable.vue";
import ProcessSteps from "@/tools/msa/components/ProcessSteps.vue";
import LoadingOverlay from "@/tools/msa/components/LoadingOverlay.vue";
import DocumentManager from "@/tools/msa/components/layout/DocumentManager.vue";
import DocumentDropdown from "@/tools/msa/components/DocumentDropdown.vue";
import DocumentView from "@/tools/msa/components/layout/DocumentView.vue";
import ModeButton from "@/components/ModeButton.vue";
import PdfView from "@/tools/msa/components/layout/PdfView.vue";
import ClearButton from "@/tools/msa/components/ClearButton.vue";
import SettingsButton from "@/components/SettingsButton.vue";
import AuthPanel from "@/components/AuthPanel.vue";
import ExportView from "@/tools/msa/components/export/ExportView.vue";
import { waitTicks } from "@/tools/msa/utils/ticks";
import SortButton from "@/tools/msa/components/SortButton.vue";
import ExportButton from "@/tools/msa/components/export/ExportButton.vue";
import FileButton from "@/tools/msa/components/persistence/FileButton.vue";

export default defineComponent({
  components: {
    FileButton,
    ExportButton,
    ExportView,
    AuthPanel,
    SettingsButton,
    ClearButton,
    PdfView,
    ModeButton,
    DocumentView,
    DocumentDropdown,
    DocumentManager,
    ItemTable,
    LoadingOverlay,
    SortButton,
    ProcessSteps,
    ProcessStep
  },
  setup() {
    const { state, send } = useMachine(machine);

    const selected = ref<Item | null>(null);

    const isExporting = ref<boolean>(false);

    watch(
      () => state.value.context.session,
      (a, b) => {
        if (a !== b) {
          document.value =
            state.value.context.session !== null
              ? state.value.context.session.documents[0]
              : null;
        }
      }
    );

    const handlePageChange = async (event: { item: Item }) => {
      isExporting.value = false;
      await waitTicks(3);
      document.value = event.item.document;
      await waitTicks(5);
      selected.value = event.item;
    };

    const collapsePanes = ref(false);

    return {
      isExporting,
      document,
      selected,
      state,
      send,
      collapsePanes,
      isLoading,
      handlePageChange
    };
  }
});
